const routeDefaultState = {
  route: {},
}

export default routeDefaultState
